export const locationKeys = {
  all: (orgId: string) => ["locations", orgId] as const,
  detail: (orgId: string, id: string) => ["locations", orgId, id] as const,
};
